// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prism-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
}

.prism-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.prism-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  outline: none;
}

.prism-modal-content.mobile {
  height: 100%;
  padding-top: 1rem;
}

.prism-modal-content.desktop {
  animation: fadeIn 0.2s ease-in-out;
}

.prism-session-view {
  overflow: hidden;
  color: #1a1a1a;
  position: relative;
}

.prism-session-view.mobile {
  height: 100%;
  width: 100vw;
  max-width: 550px;
}

.prism-session-view.desktop {
  border-radius: 1.5rem;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  outline: none;
}

.prism-modal-inner {
  background-color: #f3f4f6;
}

.prism-modal-inner.mobile {
  height: 100%;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}

.prism-modal-inner.desktop {
  height: 80vh;
  width: 45vh;
  border-radius: 1.5rem;
}

.prism-modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: var(--close-button-background-color, #ffffff);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  z-index: 10;
}

.prism-modal-close:hover {
  background-color: #f3f4f6;
  transform: scale(1.05);
}

.prism-modal-close:active {
  transform: scale(0.95);
}

.prism-modal-close-icon {
  width: 1rem;
  height: 1rem;
  position: relative;
}

.prism-modal-close-icon::before,
.prism-modal-close-icon::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: var(--close-button-icon-color, #4b5563);
  top: 50%;
  left: 0;
}

.prism-modal-close-icon::before {
  transform: rotate(45deg);
}

.prism-modal-close-icon::after {
  transform: rotate(-45deg);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: scale(1);
  }

  to {
    opacity: 0;
    transform: scale(0.95);
  }
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
}

.prism-modal-content.desktop {
  animation: fadeIn 0.2s ease-in-out;
}

.ReactModal__Content--after-close.desktop {
  animation: fadeOut 0.2s ease-in-out forwards;
}

.ReactModal__Overlay--after-close {
  opacity: 0;
}

.ReactModal__Overlay {
  transition: opacity 0.2s ease-in-out;
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/ui/modal/Modal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB;;sCAEoC;EACpC,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+DAA+D;EAC/D,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yDAAyD;EACzD,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,UAAU;AACZ","sourcesContent":[".prism-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n}\n\n.prism-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.prism-modal-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n}\n\n.prism-modal-content.mobile {\n  height: 100%;\n  padding-top: 1rem;\n}\n\n.prism-modal-content.desktop {\n  animation: fadeIn 0.2s ease-in-out;\n}\n\n.prism-session-view {\n  overflow: hidden;\n  color: #1a1a1a;\n  position: relative;\n}\n\n.prism-session-view.mobile {\n  height: 100%;\n  width: 100vw;\n  max-width: 550px;\n}\n\n.prism-session-view.desktop {\n  border-radius: 1.5rem;\n  box-shadow:\n    0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  outline: none;\n}\n\n.prism-modal-inner {\n  background-color: #f3f4f6;\n}\n\n.prism-modal-inner.mobile {\n  height: 100%;\n  border-top-left-radius: 1rem;\n  border-top-right-radius: 1rem;\n}\n\n.prism-modal-inner.desktop {\n  height: 80vh;\n  width: 45vh;\n  border-radius: 1.5rem;\n}\n\n.prism-modal-close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n  background-color: var(--close-button-background-color, #ffffff);\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease;\n  z-index: 10;\n}\n\n.prism-modal-close:hover {\n  background-color: #f3f4f6;\n  transform: scale(1.05);\n}\n\n.prism-modal-close:active {\n  transform: scale(0.95);\n}\n\n.prism-modal-close-icon {\n  width: 1rem;\n  height: 1rem;\n  position: relative;\n}\n\n.prism-modal-close-icon::before,\n.prism-modal-close-icon::after {\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 2px;\n  background-color: var(--close-button-icon-color, #4b5563);\n  top: 50%;\n  left: 0;\n}\n\n.prism-modal-close-icon::before {\n  transform: rotate(45deg);\n}\n\n.prism-modal-close-icon::after {\n  transform: rotate(-45deg);\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(100%);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n}\n\n.prism-modal-content.desktop {\n  animation: fadeIn 0.2s ease-in-out;\n}\n\n.ReactModal__Content--after-close.desktop {\n  animation: fadeOut 0.2s ease-in-out forwards;\n}\n\n.ReactModal__Overlay--after-close {\n  opacity: 0;\n}\n\n.ReactModal__Overlay {\n  transition: opacity 0.2s ease-in-out;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
